export function inputEmptyChecker(value) {
	return value?.trim().length === 0;
}
